import type { HGGetClubTournStructuresReply } from '@ps/web-shared-api-types/v1-preview/SwHomeGames';
import produce from 'immer';

import type { PageData } from '../../types/common';

export const setTournamentStructures = (
  state: PageData,
  { response }: { response: HGGetClubTournStructuresReply }
) =>
  produce(state, (draft) => {
    draft.tournamentStructures = response;
  });
